import styled from "@emotion/styled";

export const Header = styled.header`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  position: relative;
  width: 100%;
`;
